<template>
  <v-card elevation="1" class="mb-4" v-if="isProductCompany()">
    <v-card-text>
      <h6 class="text-h6 black--text">Stock</h6>
      <p class="text-body-2">Indique si el remito ingresa mercaderia al stock</p>

      <v-row>
        <v-col md="6">
          <v-radio-group 
            data-vv-as="remito incluye stock" 
            name="stock_purchase_remito" 
            v-model="remito.stock_purchase_remito" 
            row 
            @change="changeIncludeStock()" 
            v-validate="'required'" 
            :disabled="isViewModal"
          >
            <v-radio label="Con stock" :value="true" color="primary"></v-radio>
            <v-radio label="Sin stock" :value="false" color="primary"></v-radio>
          </v-radio-group>
          <span class="red--text">{{ errors.first("stock_purchase_remito") }}</span>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col md="6" v-if="remito.stock_purchase_remito != null && remito.stock_purchase_remito">
          <v-combobox
            v-model="remito.warehouse"
            data-vv-as="deposito"
            name="warehouse"
            item-text="name"
            item-value="id"
            :items="warehouses"
            label="Deposito*"
            :v-validate="isRequired()"
            autocomplete="off"
            :disabled="isViewModal"
            v-validate="'required|combobox_required'"
          ></v-combobox>
          <span class="red--text">{{ errors.first("warehouse") }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Constant from "@/constants/sections";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import { generalService } from "@/libs/ws/generalService";

export default {
  created() {
    this.$validator = this.validator;
  },
  components: {},
  mixins: [SettingsMixin],
  props: {
    remito: Object,
    isViewModal: Boolean,
    validator: Object,
  },
  data: () => ({
    warehouses: [],
  }),
  watch: {},
  mounted() {
    this.loadComboData();
  },
  methods: {
    changeIncludeStock() {
      if (!this.remito.stock_purchase_remito) {
        this.remito.warehouse = null;
      } else {
        //Auto select default
        this.warehouses.forEach((element) => {
          if (element.default_warehouse) {
            this.remito.warehouse = element;
          }
        });
      }
    },
    isRequired() {
      return this.remito.stock_purchase_remito ? "required" : "";
    },
    loadComboData() {
      generalService.setSection(Constant.SECTION_WAREHOUSES);
      generalService
        .filter({ enabled: true })
        .then((response) => {
          this.warehouses = response.result;
          this.loading = false;
        })
        .catch((e) => {
          console.log("warehouses.filter error");
          console.log(e);
          this.loading = false;
        });
    },
  },
};
</script>
